module.exports = __webpack_public_path__ + "img/switch-on.70cdd4b4.svg";